import clsx from 'clsx';
import React from 'react';
import { ThemeVariants } from '../../types';

export type ProgressBarProps = {
  percentage: number;
  variant: ThemeVariants<'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info'>;
};

const styleMap: {
  [key in ProgressBarProps['variant']]: string;
} = {
  primary: 'bg-content-brand',
  secondary: 'bg-content-secondary',
  success: 'bg-content-positive',
  warning: 'bg-content-warning',
  danger: 'bg-content-negative',
  info: 'bg-content-informative',
};

export const ProgressBar: React.FunctionComponent<ProgressBarProps> = ({ percentage, variant, ...rest }) => (
  <div {...rest} className="h-1 w-full relative bg-outline-neutral-light">
    <div
      className={clsx(styleMap[variant], 'absolute top-0 left-0 h-full')}
      style={{ width: `${percentage < 0 ? 0 : percentage > 100 ? 100 : Math.round(percentage)}%` }}
    />
  </div>
);
